import { render, staticRenderFns } from "./EditTestkit.vue?vue&type=template&id=c3241cf0&scoped=true&"
import script from "./EditTestkit.vue?vue&type=script&lang=js&"
export * from "./EditTestkit.vue?vue&type=script&lang=js&"
import style0 from "./EditTestkit.vue?vue&type=style&index=0&id=c3241cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3241cf0",
  null
  
)

export default component.exports